import { mergeRight } from "ramda";

export const mergeUser = (user, setUser) => (userWithUpdatedProp) => {
  setUser(mergeRight(user, userWithUpdatedProp));
};
